import Container from './EarningsDisplay.container';
import EarningsDisplay from './EarningsDisplay';
export default Container(EarningsDisplay);
